import axios from "../auth/FetchInterceptor";

export const getAllManagers = async (page = 1, limit = 10) => {
  const response = await axios.get(`/manager?page=${page}&limit=${limit}`);
  return response;
};

export const createManager = async (data) => {
  const response = await axios.post("/manager", data);
  return response.data;
};

export const updateManager = async (id, data) => {
  const response = await axios.put(`/manager/${id}`, data, {
    headers: {
      "Content-Type": "multipart/form-data",
    },
  });
  return response.data;
};

export const deleteManager = async (id) => {
  const response = await axios.delete(`/manager/${id}`);
  return response.data;
};
